import type {JSONValue} from 'types';
import {getOffset} from 'services/utils/getOffset';
import {INTERNATIONAL_AGENTS} from '../../advancedSearch/types';
import type {SearchProps, WorkSearchProps} from '../types';
import workQuery from '../data/workQuery.json';
import {normalizeQuery} from '../functions';

const WORK_INDEX = 'ebs-work-alias';

export const mapWorkSearchPropsToSearchProps = ({
  query,
  page,
  size,
  includeInternationalWorks,
  abortSignal,
}: WorkSearchProps): SearchProps => {
  const normalizedQuery = normalizeQuery(query);
  const from = getOffset(page, size);

  const excludedOwners = includeInternationalWorks ? [] : INTERNATIONAL_AGENTS;

  // The template carries the full elastic body including `from`/`size`/
  // `highlight`. The `"${FROM_PLACEHOLDER}"` and `"${SIZE_PLACEHOLDER}"`
  // tokens are quoted strings in the JSON; substituting with unquoted
  // numbers turns them into numeric fields once re-parsed.
  const elasticBody = JSON.parse(
    JSON.stringify(workQuery)
      .replaceAll('${QUERY_PLACEHOLDER}', normalizedQuery)
      .replaceAll('"${FROM_PLACEHOLDER}"', String(from))
      .replaceAll('"${SIZE_PLACEHOLDER}"', String(size))
      .replaceAll(
        '"${EXCLUDED_PRODUCTOWNERS_PLACEHOLDER}"',
        JSON.stringify(excludedOwners),
      ),
  ) as JSONValue;

  return {
    target: '_search',
    index: WORK_INDEX,
    elasticBody,
    abortSignal,
  };
};
